import Loadable from 'react-loadable';
import { PageLoadableComponent } from 'components/PageLoader/PageLoader';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "App" */ /* webpackPrefetch: true */ './App'),
  loading: PageLoadableComponent,
  delay: 0
});
